// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"SvgIcon-module--svgIcon--1nGJ6"};